
<template>
    <div class="keyCard" v-show="managerInfo.comparison">
        <div class="graphColor" :style="{backgroundColor: managerInfo.color}"></div>
        <div class="detailsWrapper" @click="highlightOnComparisonGraph()">
            <div class="managerTitle" :title="$store.state.universe.data.keyData[managerInfo.ticker].id">
                {{$store.state.universe.data.keyData[managerInfo.ticker].name}}
            </div>
            <div class="sector" :style="{color: sectorColour}">
                {{$store.state.universe.data.keyData[managerInfo.ticker].categories[0]}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'managerKeyCard',
    props: ['managerInfo', 'arrayIndex'],
    data () {
        return {
            positionArray: ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th', '13th', '14th', '15th', '16th'],
        };
    },
    methods: {
        highlightOnComparisonGraph () {
        },
    },
    computed: {
        compared () {
            return this.managerInfo.comparison ? 'isCompared' : 'notCompared';
        },
        sectorColour () {
            const sectorName = this.$store.state.universe.data.keyData[this.managerInfo.ticker].categories[0];
            const sectorIndex = this.$store.state.universe.data.categoryDimensions[0].order.indexOf(sectorName);
            return this.$store.state.universe.data.categoryDimensions[0].colors[sectorIndex];
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
.keyCard {
    padding:0px;
    margin-bottom: 0px;
    @include easeInOut(1.0s);
        .iconTrash:before {
            content: '\e934';
            cursor: pointer;
            font-family: 'icomoon' !important;
            font-size: 26px;
            font-style: normal;
            font-variant: normal;
            font-weight: normal;
            line-height: 1;
            position: absolute;
            right: 20px;
            speak: none;
            text-transform: none;
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
        .iconCompare:before {
            cursor: pointer;
            font-family: 'icomoon' !important;
            font-size: 26px;
            font-style: normal;
            font-variant: normal;
            font-weight: normal;
            left: 20px;
            line-height: 1;
            position: absolute;
            speak: none;
            text-transform: none;
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
        .isCompared:before {
            content: '\e90e';
        }
        .isCompared:hover:before {
            content: '\e935';
        }
        .notCompared:before {
            content: '\e937';
        }
        .notCompared:hover:before {
            content: '\e936';
        }
        .assetTypeCircle {
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            background-color: transparent;
            border-left: 5px solid $lightBlue;
            border-radius: 30px;
            border-right: 5px solid $darkBlue;
            box-sizing: border-box;
            height: 60px;
            margin: 5px auto;
            position: relative;
            width: 60px;
            .assetInitials {
                font-size: 20px;
                position: absolute;
                text-align: center;
                top: 14px;
                width: 50px;
            }
        }
        .managerTitle {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 0px;
            margin-top: 0px;
            overflow: hidden;
            text-align: left;
            width: 100%;
        }
        .sector {
            font-size: 12px;
            margin-bottom: 16px;
            width: 100%;
            .sectorColor {
                border-radius:6px;
                float: right;
                height: 12px;
                margin-top: 2px;
                width:12px;
            }
        }
        .graphColor {
            background-color: cyan;
            border-radius: 10px;
            float: left;
            height: 20px;
            margin-right: 5px;
            margin-top: 3px;
            width: 20px;
        }
        .detailsWrapper {
            cursor: pointer;
            display: inline-block;
            width: calc(100% - 40px);
        }
        .stats {
            color: $lightBlue;
            div {
                border-bottom: 1px solid $lightGrey;
                margin-bottom: 2px;
                text-align: right;
                &:last-child {
                    border-bottom: none;
                }
                span {
                    color: $darkGrey;
                    float: left;
                    font-weight: 500;
                }
            }
        }
}
</style>
